<template>
  <div class="flex flex-col">
    <div class="flex flex-col bg-gray-50 rounded-md p-2">
      <div>
        Effective Date: {{ effectiveDateDisplay }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    miscData: Object,
  },
  computed: {
    effectiveDateDisplay() {
      return this.miscData?.effective_date
    },
  },
}
</script>
